export default __webpack_public_path__ + "static/media/A4 large 5.f9ca6fd9.jpg";